import { generateIconComponent } from './icons.utils';

export const ChevronRightSolidIcon = generateIconComponent({
    name: 'ChevronRightSolidIcon',
    viewBox: '0 0 24 24',
    path: (
        <path d="M6.87877 23.678L5.32203 22.1212C4.89266 21.6918 4.89266 20.9937 5.32203 20.5643L13.8874 12.0008L5.32203 3.4373C4.89266 3.00571 4.89266 2.30988 5.32203 1.8805L6.87877 0.323692C7.30814 -0.107897 8.00615 -0.107897 8.43552 0.323692L18.5577 10.444C18.9694 10.8558 19.2028 11.4173 19.2028 12.0008C19.2028 12.5844 18.9694 13.1437 18.5577 13.5576L8.43552 23.678C8.00615 24.1073 7.30814 24.1073 6.87877 23.678Z" />
    ),
});
